import BreadCrumb from "Components/Common/BreadCrumb";
import "react-toastify/dist/ReactToastify.css";
import { Card, Container, Nav, NavItem, NavLink } from "reactstrap";
import "./EcommerceOrder.scss";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { SetStateAction, useEffect, useState } from "react";
import ConfirmOrderModal from "./components/ConfirmOrderModal";
import OrderHistoryCard from "./components/OrderHistoryCard";
import classnames from "classnames";
import axios from "axios";
import { ToastContainer } from "react-toastify";
import filterIcon from "../../assets/images/filter-icon.png";
import searchIcon from "../../assets/images/search-normal.png";
import cartIcon from "../../assets/images/shopping-cart.png";
import ErrorModal from "Components/Common/ErrorModal";
import io from "socket.io-client";
import { Environment } from "environment";
import { Constant } from "utils/enums";
import Exportcsv from "./components/Exportcsv.modal";
import InfiniteScroll from "react-infinite-scroll-component";
import LordDownModal from "./components/LordDownModal";
const userStr = localStorage.getItem(Constant.seller);
const user = userStr ? JSON.parse(userStr) : null;
const userId = user?.sellerId;
var url = `${Environment.socketUrl}?userId=${userId}`
const socket = io(url);

const EcomerceOrder = (props: any) => {
  document.title = "Orders | BuyPass";
  const [counts, setCounts] = useState<any>();
  const [searchTerm, setSearchTerm] = useState("");
  const [orders, setOrders] = useState<any>();
  const [activeTab, setActiveTab] = useState("all");
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  var [statusTab, setStatusTab] = useState("all");
  const [keywordType, setKeywordType] = useState("");
  const [filterType, setFilterType] = useState("");
  const [firstInput, setFirstInput] = useState("");
  const [secondInput, setSecondInput] = useState("");
  const [startDate, setStartDate] = useState<string | null>(null);
  const [endDate, setEndDate] = useState<string | null>(null);
  const headerNavigations = [
    {
      label: "All Orders",
      value: "all",
      active: true,
      count: counts?.allCount,
    },
    {
      label: "Pending",
      value: "pending",
      active: false,
      count: counts?.pendingCount,
    },
    {
      label: "Ready To Ship",
      value: "readyToShip",
      active: false,
      count: counts?.readyToShipCount,
    },
    {
      label: "Accepted",
      value: "accepted",
      active: false,
      count: counts?.acceptedCount,
    },
    {
      label: "Rejected",
      value: "rejected",
      active: false,
      count: counts?.rejectedCount,
    },
    {
      label: "Delivered",
      value: "delivered",
      active: false,
      count: counts?.deliveredCount,
    },
    {
      label: "Cancelled",
      value: "cancelled",
      active: false,
      count: counts?.cancelledCount,
    },
    {
      label: "Return",
      value: "return",
      active: false,
      count: counts?.returnCount,
    },
  ];
  const [ConfirmModal, setConfirmModal] = useState(false);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [proofModal, setProofModal] = useState(false);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [navigations, setNavigations] = useState(headerNavigations[0]);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [totalPages, setTotalPages] = useState<number>(1);
    const [itemsPerPage, setItemsPerPage] = useState(20);
  const [showFilters, setShowFilters] = useState(false);
  const [ExportcsvModal, setExportcsvModal] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [ordersMobile, setOrdersMobile] = useState<any[]>([]);
  
  const fetchMore = () => {
  const nextPage = currentPage + 1;
  if (!hasMore) return;

  setCurrentPage(nextPage);
  onGetOrders(nextPage);
  onGetOrdersWithStatus(nextPage,activeTab,"","")
};
  const [loadModal, setLoadModal] = useState(false);
  
  const [showModal, setShowModal] = useState({
    isVisible: false,
    color: false,
  });
  const [errorMessage, setErrorMessage] = useState<string>("");

  const toggleFilters = () => {
    setShowFilters((prev) => !prev);
  };

  const onGetOrders = async (page: number) => {
    try {
      const response = await axios.get(
        `api/v1/order/sellerorders/ecommerce?page=${page}&count=${itemsPerPage}&status=${activeTab}&keyword=${searchTerm}`
      );
          if (response?.data) {
        setOrders(response.data.data);
        const newOrders = response.data.data || [];
        setOrdersMobile((prevOrders: any) => {
  const existingIds = new Set(prevOrders.map((o: any) => o._id));
  const uniqueNewOrders = newOrders.filter((o: any) => !existingIds.has(o._id));
  return [...prevOrders, ...uniqueNewOrders];
});

        setCounts(response.data.counts);
             const totalCount = response.data.totalCount;
const newTotalPages = Math.ceil(totalCount / itemsPerPage);
setTotalPages(newTotalPages);

const isLastPage = page >= newTotalPages;
setHasMore(!isLastPage);
      }
    } catch (err: any) {
    } finally {
    }
  };
       const handleItemsPerPageChange = (e:any) => {
    setItemsPerPage(Number(e.target.value));
    setCurrentPage(1); // Reset to page 1 when count changes
  };

  useEffect(() => {
    const handler = setTimeout(() => {
      onGetOrders(currentPage);
    }, 500);

    return () => {
      clearTimeout(handler);
    };
    // eslint-disable-next-line
  }, [searchTerm, currentPage]);
   useEffect(() => {
      onGetOrders(currentPage);
    // eslint-disable-next-line
  }, [itemsPerPage, currentPage]);

  useEffect(() => {
    if (startDate && endDate) {
      onGetOrdersWithStatus(1, activeTab, "", "");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startDate, endDate]);

  const filters = [
    { label: "SLA Breached", value: "slaBreached" },
    { label: "AWB Unprinted", value: "AWBUnprinted" },
    { label: "Invoice Unprinted", value: "invoiceUnprinted" },
    { label: "Picklist Unprinted", value: "picklistUnprinted" },
    { label: "Rider Handover Unprinted", value: "riderHandoverUnprinted" },
  ];

  const handleFilterClick = (filterType: string) => {
    setFirstInput("");
    setSecondInput("");
    setFilterType(filterType);

    onGetOrdersWithStatus(currentPage, activeTab, filterType, "", true);
  };

  const onGetOrdersWithStatus = async (
    page: number,
    status: any,
    filterType: string,
    keywordType: string,
    isSlaBreached = false
  ) => {
    try {
      let keyword = firstInput.trim() !== "" ? firstInput : secondInput;
      let finalKeywordType = "";
      let dateFilters = [
        "today",
        "yesterday",
        "lastSevenDays",
        "lastThirtyDays",
      ];
      let finalFilterType = dateFilters.includes(filterType) ? filterType : "";
      let statusFilters = [
        "slaBreached",
        "AWBUnprinted",
        "invoiceUnprinted",
        "picklistUnprinted",
        "riderHandoverUnprinted",
      ];
      let finalStatusType = statusFilters.includes(filterType)
        ? filterType
        : "";

      if (!filterType && firstInput.trim() !== "") {
        finalKeywordType = "orderNumber";
      } else if (!filterType && secondInput.trim() !== "") {
        finalKeywordType = "productName";
      } else {
        keyword = "";
      }

      const response = await axios.get(
        `api/v1/order/sellerorders/ecommerce?page=${page}&count=${itemsPerPage}&status=${status}&keyword=${keyword}&keyword-type=${finalKeywordType}&filter-type=${finalFilterType}&stardate=${
          startDate ? new Date(startDate).getTime() : 0
        }&enddate=${
          endDate ? new Date(endDate).getTime() : 0
        }&status-type=${finalStatusType}`
      );

            if (response?.data) {
        setOrders(response.data.data);
        const newOrders = response.data.data || [];
        setOrdersMobile((prevOrders: any) => {
  const existingIds = new Set(prevOrders.map((o: any) => o._id));
  const uniqueNewOrders = newOrders.filter((o: any) => !existingIds.has(o._id));
  return [...prevOrders, ...uniqueNewOrders];
});

        setCounts(response.data.counts);
          setStartDate(null);
        setEndDate(null);
        setTotalPages(Math.ceil(response.data.totalCount / itemsPerPage));
        const isLastPage = page >= totalPages;
        setHasMore(!isLastPage);
      }
    } catch (err: any) {
      console.error(err);
    }
  };

  useEffect(() => {
    console.log(orders);
    onGetOrders(currentPage);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage]);

  useEffect(() => {
    if (keywordType.length > 3) {
      onGetOrdersWithStatus(currentPage, activeTab, keywordType, "");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [keywordType]);

  useEffect(() => {
    console.log("filterType changed:", filterType);
    if (filterType === "slaBreached") {
      console.log("Skipping API call because status-type is slaBreached");
      return;
    }
    if (firstInput.trim() !== "") {
      onGetOrdersWithStatus(currentPage, activeTab, "", "orderNumber");
    } else if (secondInput.trim() !== "") {
      onGetOrdersWithStatus(currentPage, activeTab, "", "productName");
    } else if (filterType && filterType.trim() !== "") {
      onGetOrdersWithStatus(currentPage, activeTab, filterType.trim(), "");
    } else {
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [firstInput, secondInput, currentPage, filterType]);

  const tabs = [
    {
      label: "To be Handover",
      count: counts?.handedoverCount,
      status: "handedOver",
    },
    {
      label: "In Transit",
      count:
        (counts?.orderPickupCount || 0) +
        (counts?.departedCount || 0) +
        (counts?.attemptForDeliveryCount || 0) +
        (counts?.reachedByBuyerCityCount || 0),
      status: "inTransit",
    },
  ];

  useEffect(() => {
    socket.on("getOrderData", () => {
      onGetOrders(currentPage);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

    useEffect(() => {
    setOrdersMobile([]);
    setCurrentPage(1);
    setHasMore(true);
    onGetOrders(1);
  }, [activeTab, statusTab,searchTerm]);


   const handlePageChange = (page: number) => {
      setCurrentPage(page);
    };

  return (
    <div className="page-content page-content-mobile EcommerceordersMainPage">
      <ToastContainer />
      <ErrorModal
        show={showModal.isVisible}
        message={errorMessage}
        color={showModal.color}
        onCloseClick={() => setShowModal({ isVisible: false, color: false })}
      />
      <Container fluid>
        <BreadCrumb
          title="Manage E Commerce Orders"
          pageTitle="Orders"
          pageTitleRoute="/manage-products"
        />

        <ConfirmOrderModal
          show={ConfirmModal}
          onCloseClick={() => setConfirmModal(false)}
        />
        <Exportcsv
       show={ExportcsvModal}
       countPage={itemsPerPage}
       onCloseClick={() => setExportcsvModal(false)}
       isQuickCommerce={false}
       />

      <LordDownModal
       show={loadModal}
       isQuickCommerce={false}       
       onCloseClick={() => setLoadModal(false)}
       />


        <Card>
          <div className="navigatiovCardDv">
            <div className="OrderCardHeader">
            <h2>Order History</h2>
           <div className="mobile-hide ">
            <button style={{ cursor: "pointer" }} className="me-2" onClick={() => setExportcsvModal(true)} >Export CSV</button>
             <button style={{ cursor: "pointer" }}  onClick={() => setLoadModal(true)}>Download Load Sheet</button>
            {/* <button style={{ cursor: "pointer" }} onClick={() => setExportcsvModal(true)}>Export CSV</button> */}
           </div>
            </div>
            {counts && (
              <Nav
                className="nav-tabs nav-tabs-custom nav-success"
                role="tablist"
              >
                <NavItem>
                  <NavLink
                    className={classnames({ active: activeTab === "all" })}
                    href="#"
                    onClick={() => {
                      setCurrentPage(1);
                      onGetOrdersWithStatus(
                        currentPage,
                        "all",
                        keywordType,
                        ""
                      );
                      setActiveTab("all");
                      setShowFilters(false);
                    }}
                    data-testing-id="all_orders"
                  >
                    <img
                      src={cartIcon}
                      style={{ width: "18px", marginRight: "6px" }}
                      alt=""
                    />
                    All Orders
                    <span className="badge bg-danger-subtle text-danger align-middle rounded-pill ms-1">
                      {counts.allCount}
                    </span>
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames({ active: activeTab === "newOrder" })}
                    href="#"
                    data-testing-id="newOrderTabar_orders"
                    onClick={() => {
                      setCurrentPage(1);
                      onGetOrdersWithStatus(
                        currentPage,
                        "newOrder",
                        keywordType,
                        ""
                      );
                      setActiveTab("newOrder");
                      setShowFilters(false);
                    }}
                  >
                    New Orders
                    <span className="badge bg-danger-subtle text-danger align-middle rounded-pill ms-1">
                      {counts.newOrderCount}
                    </span>
                  </NavLink>
                </NavItem>

                <NavItem>
                  <NavLink
                    className={classnames({
                      active: activeTab === "orderAccepted",
                    })}
                    href="#"
                    data-testing-id="acceptedTabbar_orders"
                    onClick={() => {
                      setCurrentPage(1);
                      onGetOrdersWithStatus(
                        currentPage,
                        "orderAccepted",
                        keywordType,
                        ""
                      );
                      setActiveTab("orderAccepted");
                      setShowFilters(false);
                    }}
                  >
                    Accepted
                    <span className="badge bg-danger-subtle text-danger align-middle rounded-pill ms-1">
                      {counts.acceptedCount}
                    </span>
                  </NavLink>
                </NavItem>

                <NavItem>
                  <NavLink
                    className={classnames({
                      active: activeTab === "readyToShip",
                    })}
                    href="#"
                    data-testing-id="ReadytoShip_orders"
                    onClick={() => {
                      setCurrentPage(1);
                      onGetOrdersWithStatus(
                        currentPage,
                        "readyToShip",
                        keywordType,
                        ""
                      );
                      setActiveTab("readyToShip");
                      setShowFilters(false);
                    }}
                  >
                    Ready To Ship
                    <span className="badge bg-danger-subtle text-danger align-middle rounded-pill ms-1">
                      {counts?.readyToShipCount}
                    </span>
                  </NavLink>
                </NavItem>
                {/* 
                <NavItem>
                  <NavLink
                    className={classnames({ active: activeTab === "readyToShip" })}
                    href="#"
                    data-testing-id="readyToShipTabar_orders"
                    onClick={() => {
                      setCurrentPage(1);
                      onGetOrdersWithStatus(currentPage, "readyToShip");
                      setActiveTab("readyToShip");
                    }}
                  >
                    Ready To Ship
                    <span className="badge bg-danger-subtle text-danger align-middle rounded-pill ms-1">
                      {counts.readyToShipCount}
                    </span>
                  </NavLink>
                </NavItem> */}
                {/* <NavItem>
                  <NavLink
                    className={classnames({
                      active: activeTab === "packingOrder",
                    })}
                    href="#"
                    data-testing-id="packingOrderTabbar_campaign"
                    onClick={() => {
                      setCurrentPage(1);
                      onGetOrdersWithStatus(currentPage, "packingOrder");
                      setActiveTab("packingOrder");
                    }}
                  >
                    Ready To Ship
                    <span className="badge bg-danger-subtle text-danger align-middle rounded-pill ms-1">
                      {counts.packingCount}
                    </span>
                  </NavLink>
                </NavItem> */}
                <NavItem>
                  <NavLink
                    className={classnames({
                      active: activeTab === "handedOver",
                    })}
                    href="#"
                    data-testing-id="riderAssignedTabbar_campaign"
                    onClick={() => {
                      setCurrentPage(1);
                      onGetOrdersWithStatus(
                        currentPage,
                        "handedOver",
                        keywordType,
                        ""
                      );
                      setActiveTab("handedOver");
                      setShowFilters(false);
                    }}
                  >
                    Shipping
                    <span className="badge bg-danger-subtle text-danger align-middle rounded-pill ms-1">
                      {counts?.handedoverCount}
                    </span>
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames({
                      active: activeTab === "delivered",
                    })}
                    href="#"
                    data-testing-id="deliveredTabbar_campaign"
                    onClick={() => {
                      setCurrentPage(1);
                      onGetOrdersWithStatus(
                        currentPage,
                        "delivered",
                        keywordType,
                        ""
                      );
                      setActiveTab("delivered");
                      setShowFilters(false);
                    }}
                  >
                    Delivered
                    <span className="badge bg-danger-subtle text-danger align-middle rounded-pill ms-1">
                      {counts?.deliveredCount}
                    </span>
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames({
                      active: activeTab === "cancelledByBuyer",
                    })}
                    href="#"
                    data-testing-id="cancelledByBuyerTabbar_orders"
                    onClick={() => {
                      setCurrentPage(1);
                      onGetOrdersWithStatus(
                        currentPage,
                        "cancelledByBuyer",
                        keywordType,
                        ""
                      );
                      setActiveTab("cancelledByBuyer");
                      setShowFilters(false);
                    }}
                  >
                    Cancelled
                    <span className="badge bg-danger-subtle text-danger align-middle rounded-pill ms-1">
                      {counts?.cancelledByBuyerCount}
                    </span>
                  </NavLink>
                </NavItem>

                {/* <NavItem>
                  <NavLink
                    className={classnames({
                      active: activeTab === "readyToShip",
                    })}
                    href="#"
                    data-testing-id="readyToShipTabbar_orders"
                    onClick={() => {
                      setCurrentPage(1);
                      onGetOrdersWithStatus(currentPage, "readyToShip");
                      setActiveTab("readyToShip");
                    }}
                  >
                    Ready To Ship
                    <span className="badge bg-danger-subtle text-danger align-middle rounded-pill ms-1">
                      {counts.readyToShipCount}
                    </span>
                  </NavLink>
                </NavItem> */}

                <NavItem>
                  <NavLink
                    className={classnames({
                      active: activeTab === "cancelledBySeller",
                    })}
                    href="#"
                    data-testing-id="rejectedTabbar_campaign"
                    onClick={() => {
                      setCurrentPage(1);
                      onGetOrdersWithStatus(
                        currentPage,
                        "cancelledBySeller",
                        keywordType,
                        ""
                      );
                      setActiveTab("cancelledBySeller");
                      setShowFilters(false);
                    }}
                  >
                    Rejected
                    <span className="badge bg-danger-subtle text-danger align-middle rounded-pill ms-1">
                      {counts?.cancelledBySellerCount}
                    </span>
                  </NavLink>
                </NavItem>
              </Nav>
            )}
            {["handedOver", "inTransit"].includes(activeTab) && orders?.length > 0 && (
                <div className="tab-bar">
                  {tabs.map((tab) => (
                    <div
                      key={tab.label}
                      className={`tab ${
                        activeTab === tab.status ? "active" : ""
                      }`}
                      onClick={() => {
                        if (tab.label === "To be Handover") {
                          setActiveTab(tab.status);
                          onGetOrdersWithStatus(1, tab.status, "", "", false); // API call
                        } else if (tab.label === "In Transit") {
                          onGetOrdersWithStatus(1, tab.status, "", "", false);
                          setActiveTab(tab.status);
                        }
                      }}
                    >
                      <span className="count">({tab.count})</span>
                      {tab.label}
                    </div>
                  ))}
                </div>
              )}

            <div className="serchNavigationDv">
               <div className="SearchandExport">
                 <div className="serchDv w-100">
                <i className="bx bx-search"></i>
                <input
                  type="text"
                  placeholder="Search"
                  data-testing-id="serachInput_order"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />

                  </div>
              </div>
             



              <div className="paginationDv mobile-hide">
                <nav aria-label="Page navigation example">
                  <ul className="pagination detailPagepagi">
                     <select value={itemsPerPage} style={{margin:'5px'}} onChange={handleItemsPerPageChange}>
          <option value={20}>20</option>
          <option value={50}>50</option>
          <option value={80}>80</option>
          <option value={100}>100</option>
        </select>
                    <li
                      className={`page-item ${
                        currentPage === 1 ? "disabled" : ""
                      }`}
                    >
                      <button
                        style={{
                          height: "26px",
                          display: "flex",
                          alignItems: "center",
                          border: "none",
                        }}
                        className="page-link"
                        onClick={() =>
                          setCurrentPage((prev) => Math.max(prev - 1, 1))
                        }
                      >
                        <i
                          style={{ height: "11px" }}
                          className="bx bxs-left-arrow"
                        ></i>
                      </button>
                    </li>
                     {Array.from({ length: Math.min(totalPages, 5) }, (_, i) => {
  let startPage = 1;

  if (totalPages <= 5) {
    startPage = 1;
  } else if (currentPage <= 3) {
    startPage = 1;
  } else if (currentPage >= totalPages - 2) {
    startPage = totalPages - 4;
  } else {
    startPage = currentPage - 2;
  }

  return startPage + i;
                    }).map((page) => (
                      <div>
                        <li
                          className={`page-item ${
                            currentPage === page ? "active" : ""
                          }`}
                          key={page}
                        >
                          <button
                            style={{ height: "26px" }}
                            className="page-link orderPg"
                            onClick={() => setCurrentPage(page)}
                          >
                            {page}
                          </button>
                        </li>
                      </div>
                    ))}

                    <li
                      className={`page-item ${
                        currentPage === totalPages ? "disabled" : ""
                      }`}
                    >
                      <button
                        style={{
                          height: "26px",
                          display: "flex",
                          alignItems: "center",
                          border: "none",
                        }}
                        className="page-link orderPg"
                        onClick={() =>
                          setCurrentPage((prev) =>
                            Math.min(prev + 1, totalPages)
                          )
                        }
                      >
                        <i
                          className="bx bxs-right-arrow"
                          style={{ width: "6px", height: "11px" }}
                        ></i>
                      </button>
                    </li>
                    <select
    value={currentPage}
    onChange={(e) => handlePageChange(Number(e.target.value))}
    style={{
      margin: "0 10px",
      padding: "2px 6px",
      borderRadius: "4px",
      border: "1px solid #ccc",
      fontSize: "13px",
    }}
  >
    {Array.from({ length: totalPages }, (_, i) => i + 1).map((pageNum) => (
      <option key={pageNum} value={pageNum}>
        Page {pageNum}
      </option>
    ))}
  </select>
                  </ul>
                </nav>
              </div>
            </div>
            <div className=" w-100 mobile-show mb-2" >
             <div className=" d-flex gap-2  w-100 " style={{padding:'0px 20px'}}>
             <button className="btn btn-secondary loadSheetBtn" style={{ cursor: "pointer" }}  onClick={() => setLoadModal(true)}>Download Load Sheet</button>
              <button className="btn btn-secondary csvBtn" style={{ cursor: "pointer" }} onClick={() => setExportcsvModal(true)} >Export CSV</button>
              </div>
              </div>
            <div className="tableHead">
              <div className="tableHeadChild firtChild">
                <h4>Product</h4>
              </div>
              <div className="tableHeadChild secondChild">
                <h4>Total Amount</h4>
              </div>
              <div className="tableHeadChild ThirdChild">
                <h4>Delivery Type</h4>
              </div>
              <div className="tableHeadChild fourthChild">
                <h4>Order Status</h4>
              </div>
              <div className="tableHeadChild">
                <h4>Actions</h4>
              </div>
              <div
                style={{ alignItems: "baseline" }}
                className="tableHeadChild lastChild d-flex cursor-pointer"
                data-testing-id="Filter_ecommerceoder"
                onClick={toggleFilters}
              >
                <img
                  src={filterIcon}
                  style={{ width: "13px", height: "13px", marginRight: "5px" }}
                  alt=""
                />
                <h4 className="text-secondary m-0">Filter</h4>
              </div>
            </div>
            {showFilters && (
              <div className="chipTodayContainer-main">
                <div className="chipTodayContainer">
                  {filters.map((filter) => (
                    <p
                      key={filter.value}
                      className={`chipDv ${
                        filterType === filter.value ? "active" : ""
                      }`}
                      tabIndex={0}
                      // data-testing-id={filters}

                      data-testing-id={`selectFilters_EcommercerOrder_${filter.value}`}
                      onClick={() => handleFilterClick(filter.value)}
                      onBlur={() => setFilterType("")}
                    >
                      {filter.label}
                    </p>
                  ))}

                  <p
                    className={`chipDv ${
                      filterType === "today" ? "active" : ""
                    }`}
                    tabIndex={0}
                    onClick={() => {
                      setFirstInput("");
                      setSecondInput("");
                      setFilterType("today");
                      onGetOrdersWithStatus(
                        currentPage,
                        activeTab,
                        "today",
                        ""
                      );
                    }}
                    onBlur={() => setFilterType("")}
                    data-testing-id={`selectFilters_EcommercerOrder_Today`}
                  >
                    Today
                  </p>

                  <p
                    className={`chipDv ${
                      filterType === "yesterday" ? "active" : ""
                    }`}
                    tabIndex={0}
                    onClick={() => {
                      setFirstInput("");
                      setSecondInput("");
                      setFilterType("yesterday");
                      onGetOrdersWithStatus(
                        currentPage,
                        activeTab,
                        "yesterday",
                        ""
                      );
                    }}
                    onBlur={() => setFilterType("")}
                    data-testing-id={`selectFilters_EcommercerOrder_Yesterday`}
                  >
                    Yesterday
                  </p>

                  <p
                    className={`chipDv ${
                      filterType === "lastSevenDays" ? "active" : ""
                    }`}
                    tabIndex={0}
                    onClick={() => {
                      setFirstInput("");
                      setSecondInput("");
                      setFilterType("lastSevenDays");
                      onGetOrdersWithStatus(
                        currentPage,
                        activeTab,
                        "lastSevenDays",
                        ""
                      );
                    }}
                    onBlur={() => setFilterType("")}
                    data-testing-id={`selectFilters_EcommercerOrder_lastSevenDays`}
                  >
                    Last 7 Days
                  </p>

                  <p
                    className={`chipDv ${
                      filterType === "lastThirtyDays" ? "active" : ""
                    }`}
                    tabIndex={0}
                    onClick={() => {
                      setFirstInput("");
                      setSecondInput("");
                      setFilterType("lastThirtyDays");
                      onGetOrdersWithStatus(
                        currentPage,
                        activeTab,
                        "lastThirtyDays",
                        ""
                      );
                    }}
                    onBlur={() => setFilterType("")}
                    data-testing-id={`selectFilters_EcommercerOrder_lastThirtyDays`}
                  >
                    Last 30 Days
                  </p>

                  {/* <p className="chipDv" data-testing-id="selectFilters_EcommercerOrder">Custom</p> */}
                  <div className="input">
                    <input
                      type="date"
                      data-testing-id="startDateInput_EcommercerOrder"
                      placeholder="Start Date"
                      value={startDate || ""}
                      onChange={(e) => {
                        setStartDate(e.target.value);
                        if (
                          endDate &&
                          new Date(e.target.value) > new Date(endDate)
                        ) {
                          setEndDate(e.target.value);
                        }
                      }}
                    />

                    <input
                      type="date"
                      data-testing-id="endDateInput_EcommercerOrder"
                      placeholder="End Date"
                      value={endDate || ""}
                      onChange={(e) => {
                        if (
                          startDate &&
                          new Date(e.target.value) < new Date(startDate)
                        ) {
                          setErrorMessage(
                            "End date cannot be before start date!"
                          );
                          setShowModal({ isVisible: true, color: false });
                          setTimeout(() => {
                            setShowModal({ isVisible: false, color: false });
                          }, 1500);
                          return;
                        }

                        setEndDate(e.target.value);
                      }}
                    />
                  </div>
                </div>
                <div className="input-main">
                  <div className="input">
                    <input
                      type="text"
                      placeholder="Order Number"
                      data-testing-id="orderNumberInput_EcommercerOrder"
                      value={firstInput}
                      onChange={(e) => {
                        setFirstInput(e.target.value);
                        setKeywordType("orderNumber");
                      }}
                      onFocus={() => {
                        setSecondInput(""); // Clear Product Name
                        setKeywordType("");
                      }}
                    />
                    <img src={searchIcon} alt="" />
                  </div>

                  <div className="input">
                    <input
                      type="text"
                      placeholder="Product Name"
                      data-testing-id="producyNameInput_EcommercerOrder"
                      value={secondInput}
                      onChange={(e) => {
                        setSecondInput(e.target.value);
                        setKeywordType("productName");
                      }}
                      onFocus={() => {
                        setFirstInput("");
                        setKeywordType("");
                      }}
                    />
                    <img src={searchIcon} alt="" />
                  </div>
                  {/* <div className="input">
                    <select name="" id="" data-testing-id="select_EcommercerOrder">
                      <option value="" data-testing-id="selectOption_EcommercerOrder">Select filter</option>
                      <option value="" data-testing-id="selectOption_EcommercerOrder">Select filters</option>
                    </select>
                  </div> */}
                </div>
              </div>
            )}
          </div>
        </Card>
        {/* {navigations.label === "All Orders" && (
          <>
            <div className="mobileViewScroll">
              {orders && orders.length > 0 ? (
                orders.map((order: any, index: any) => (
                  <OrderHistoryCard
                    key={order._id}
                    order={order}
                    index={index}
                    activeTab={activeTab}
                    setOrders={setOrders}
                    setTotalPages={setTotalPages}
                  />
                ))
              ) : (
                <h2>No Data Found!</h2>
              )}
            </div>
          </>
        )} */}
          {navigations.label === "All Orders" && (
          <>
          {window.innerWidth <= 768 ? (
          <div className="mobileViewScroll">
            {ordersMobile?.length === 0 ? (
              <h2>No Data Found!</h2>
            ) : (
              <InfiniteScroll
                dataLength={ordersMobile.length}
                next={fetchMore}
                hasMore={hasMore}
                loader={<p>Loading...</p>}
                scrollThreshold={0.95}
              >
                {ordersMobile.map((o, i) => (
                  <OrderHistoryCard
                    key={o._id}
                    order={o}
                    index={i}
                    activeTab={activeTab}
                    setOrders={setOrdersMobile}
                    setTotalPages={setTotalPages}
                  />
                ))}
              </InfiniteScroll>
            )}
          </div>
        ) : (
          <div className="mobileViewScroll">
            {orders?.length > 0 ? (
              orders.map((o: { _id: any; }, i: any) => (
                <OrderHistoryCard
                  key={o._id}
                  order={o}
                  index={i}
                  activeTab={activeTab}
                  setOrders={setOrders}
                  setTotalPages={setTotalPages}
                />
              ))
            ) : (
              <h2>No Data Found!</h2>
            )}
          </div>
        )}
        
          </>
        )}
        
      </Container>
    </div>
  );
};

export default EcomerceOrder;
